<template>
<!-- HISTORY: no-version
   V250918.1: Made the iframe height dynamic and adjustable.
   V250917.2: 1st release.
-->
<v-container fluid class="px-0 py-0">
   <v-card :loading="loading">
      <v-card-text class="pb-0">
         <iframe
            frameborder="0"
            width="100%"
            :height="iframeHeight"
            :src="iframeUrl"
            @load="onIframeLoad"
         ></iframe>
      </v-card-text>
   </v-card>
</v-container>
</template>

<script>
const NAME = "QuickSight";

export default {
   name: NAME,

   props: {
      debug: {
         type: Boolean,
         default: false
      },

      isActualEndpoint: {
         type: Boolean,
         default: true
      }
   },

   data() {
      return {
         loading: true,
         iframeHeight: window.innerHeight - 108
      }
   },

   computed: {
      token() {
         return this.$store.getters.token;
      },

      iframeUrl() {
         return process.env.VUE_APP_QUICK_SIGHT_URL + this.token;
      }
   },

   methods: {
      onIframeLoad() {
         setTimeout(() => {
            // alert('iframe was loaded: url=' + this.iframeUrl);
            this.loading = false;
         }, 10);
      }
   },

   created() { }
}
</script>